import React from 'react'

import type { SharedConfirmInfoProps } from '@/components/purchase/components/shared/purchaseConfirmInfo/view'

import BottomSheet from '@/shared/components/BottomSheet'
import { Caption, Text } from '@/shared/components/typography/index'
import { formatTime } from '@/shared/utils/date'

const SharedConfirmInfo = ({
  isOpen,
  carNumValue,
  onClick,
  onClose,
  enteringTime,
  price,
  data
}: SharedConfirmInfoProps) => {
  const generateInfoText = () => {
    const { basic } = data
    const { category, type } = basic
    const isDefault = category === 2
    const isSection = !isDefault && type === 'SECTION'
    const isUnit = !isDefault && type === 'UNIT'

    if (isDefault) {
      return '주차 자리 사진 확인 필수'
    } else if (isUnit) {
      return '결제한 구획 외 주차 및 침범시 단속'
    } else if (isSection) {
      return '결제 구간 내 빈자리 주차'
    }
  }
  const bottomContent = (
    <div className="flex w-full flex-col">
      <div className="my-6 rounded-lg bg-main-010 px-4 py-5">
        <Text level="text1" weight="bold" color="main050" className="mb-4 text-left">
          {carNumValue}
        </Text>
        <div className="flex flex-col gap-1">
          <div className="flex justify-between">
            <Caption level="caption2" color="text070">
              주차시간
            </Caption>
            <Caption level="caption2" color="text090">
              {formatTime(enteringTime)}
            </Caption>
          </div>
          <div className="flex justify-between">
            <Caption level="caption2" color="text070">
              상품 가격
            </Caption>
            <Caption level="caption2" color="text090">
              {price.toLocaleString()}원
            </Caption>
          </div>
        </div>
      </div>
      <div className="mb-10">
        <Text level="text3" color="text090" weight="bold" className="mb-[6px] text-left">
          주차권 이용시 <span className="text-caution-070">유의사항 안내</span>
        </Text>
        <ol className="list-disc">
          <li className="list-style-desc">
            <Caption level="caption2" color="text070">
              주차자리가 비어있는지 확인 후 결제해주세요
            </Caption>
          </li>
          <li className="list-style-desc">
            <Caption level="caption2" color="text070">
              {generateInfoText()}
            </Caption>
          </li>
          <li className="list-style-desc">
            <Caption level="caption2" color="text070">
              이용 시간 중 자리 비움 불가
            </Caption>
          </li>
          <li className="list-style-desc">
            <Caption level="caption2" color="text070">
              출차 후 남은 시간 부분 환불 불가
            </Caption>
          </li>
          <li className="list-style-desc">
            <Caption level="caption2" color="text070">
              결제 후 10분 이내 취소 가능
            </Caption>
          </li>
          <li className="list-style-desc">
            <Caption level="caption2" color="text070" className="text-left">
              결제 후 2시간 이내에만 카카오톡 상담 채널로 환불 신청 가능
            </Caption>
          </li>
        </ol>
      </div>
    </div>
  )
  return (
    <BottomSheet
      isOpen={isOpen}
      title="결제 전 반드시 확인해 주세요."
      ptValue="pt-8"
      bodyContent={bottomContent}
      btnText="위 내용을 확인했습니다"
      className="body-1 h-[56px]"
      pyValue="py-0"
      onClick={onClick}
      onClose={onClose}
    />
  )
}

export default SharedConfirmInfo
